import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { FaqListWidget } from './FaqListWidget';
import { IFaqItem } from '../Faq/FaqWidget';

interface IFaqPageWidgetProps {
    faqs: string;
    dictOpinionLabel: string;
    dictOpinionVotedLabel: string;
    dictNoResultTitle: string;
    dictNoResultDescription: string;
    dictYes: string;
    dictNo: string;
    dictCommentSuccess: string;
    dictCommentFail: string;
    dictSend: string;
    dictCommentInvite: string;
    dictYourComment: string;
    contactUrl: string;
    contactString: string;
}

interface IFaqApiItem {
    Id: number;
    Question: string;
    Answer: string;
}

interface IFaqPageWidgetState {
    faqs: IFaqItem[];
}

export class FaqPageWidget extends Component<
    IFaqPageWidgetProps,
    IFaqPageWidgetState
> {
    constructor(props: IFaqPageWidgetProps) {
        super(props);

        const faqElement = document.querySelector(
            props.faqs
        ) as HTMLScriptElement;

        const apiFaqs: IFaqApiItem[] = JSON.parse(faqElement.text);

        const faqs: IFaqItem[] = apiFaqs.map((faq) => ({
            id: faq.Id,
            question: faq.Question,
            answer: faq.Answer,
        }));

        this.state = {
            faqs,
        };
    }

    render() {
        return (
            <FaqListWidget
                currentFaqId={undefined}
                faqs={this.state.faqs}
                opinionLabel={this.props.dictOpinionLabel}
                opinionVotedLabel={this.props.dictOpinionVotedLabel}
                dictNoResultTitle={this.props.dictNoResultTitle}
                dictNoResultDescription={this.props.dictNoResultDescription}
                isLoading={false}
                showNoResult={false}
                dictSend={this.props.dictSend}
                dictCommentSuccess={this.props.dictCommentSuccess}
                dictCommentFail={this.props.dictCommentFail}
                dictCommentInvite={this.props.dictCommentInvite}
                dictYourComment={this.props.dictYourComment}
                dictYes={this.props.dictYes}
                dictNo={this.props.dictNo}
                contactString={this.props.contactString}
                contactUrl={this.props.contactUrl}
            />
        );
    }
}

WidgetHelper.register(FaqPageWidget, 'faq-page-widget');
